/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  LOGIN = '[Auth] Login',
  LOGIN_SUCCESS = '[Auth] Login Success',
  LOGIN_FAILED = '[Auth] Login Failed',

  REGISTER = '[Auth] Register',
  REGISTER_SUCCESS = '[Auth] Register Success',
  REGISTER_FAILED = '[Auth] Register Failed',

  FORGOT_PASSWORD = '[Auth] Forgot Password',
  FORGOT_PASSWORD_SUCCESS = '[Auth] Forgot Password Success',
  FORGOT_PASSWORD_FAILED = '[Auth] Forgot Password Failed',

  RESET_PASSWORD = '[Auth] Reset Password',
  RESET_PASSWORD_SUCCESS = '[Auth] Reset Password Success',
  RESET_PASSWORD_FAILED = '[Auth] Reset Password Failed',

  AUTO_LOGOUT= '[Auth] Auto Logout',

}

export const login = createAction(
  ActionTypes.LOGIN,
  props<{ data: any }>()
);

export const loginSuccess = createAction(
  ActionTypes.LOGIN_SUCCESS,
  props<{ data: any }>()
);

export const loginFailed = createAction(
  ActionTypes.LOGIN_FAILED,
  props<{ data: any }>()
);

export const register = createAction(
  ActionTypes.REGISTER,
  props<{ data: any }>()
);

export const registerSuccess = createAction(
  ActionTypes.REGISTER_SUCCESS,
  props<{ data: any }>()
);

export const registerFailed = createAction(
  ActionTypes.REGISTER_FAILED,
  props<{ data: any }>()
);

export const forgotPassword = createAction(
  ActionTypes.FORGOT_PASSWORD,
  props<{ data: any }>()
);

export const forgotPasswordSuccess = createAction(
  ActionTypes.FORGOT_PASSWORD_SUCCESS,
  props<{ data: any }>()
);

export const forgotPasswordFailed = createAction(
  ActionTypes.FORGOT_PASSWORD_FAILED,
  props<{ data: any }>()
);

export const resetPassword = createAction(
  ActionTypes.RESET_PASSWORD,
  props<{ data: any }>()
);

export const resetPasswordSuccess = createAction(
  ActionTypes.RESET_PASSWORD_SUCCESS,
  props<{ data: any }>()
);

export const resetPasswordFailed = createAction(
  ActionTypes.RESET_PASSWORD_FAILED,
  props<{ data: any }>()
);

export const autoLogout = createAction(
  ActionTypes.AUTO_LOGOUT
);